"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InfoList = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var InfoList = function InfoList() {
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.5 17h15a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-9.523A8.466 8.466 0 017.5 17zm7.212-4H22.5a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-6.874a8.454 8.454 0 01-.914 2zm1.274-4H22.5a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-6.633a8.495 8.495 0 01.118 2zm-.74-4H22.5a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-8.52c.517.608.941 1.282 1.266 2zM4.5 19h10a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-10a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5z",
    clipRule: "evenodd"
  }), react_1.default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.5 2a6.5 6.5 0 100 13 6.5 6.5 0 000-13zm.65 8.775c0 .18-.145.325-.325.325h-.65a.325.325 0 01-.325-.325v-1.95c0-.18.146-.325.325-.325h.65c.18 0 .325.146.325.325v1.95zM7.825 7.2c.18 0 .325-.145.325-.325v-.65a.325.325 0 00-.325-.325h-.65a.325.325 0 00-.325.325v.65c0 .18.146.325.325.325h.65z",
    clipRule: "evenodd",
    opacity: "0.72"
  }));
};

exports.InfoList = InfoList;